var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDevice = function SvgDevice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 19h22v-4H11v49H5v4h49v-4H15V19Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 19h37v25h4V15H43v4Z",
    fill: "#8552F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m73 74.975 13.487-13.488-2.474-2.474L73 70.025l-4.013-4.012-2.474 2.474L73 74.975Z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94 65.5C94 75.165 86.165 83 76.5 83S59 75.165 59 65.5 66.835 48 76.5 48 94 55.835 94 65.5Zm-3.5 0c0 7.732-6.268 14-14 14s-14-6.268-14-14 6.268-14 14-14 14 6.268 14 14Z",
    fill: "#000"
  })));
};
export default SvgDevice;